module.exports = __webpack_public_path__ + "static/img/zhxt7.ea69075.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhxt7.png
// module id = U0TZ
// module chunks = 73